/* import __COLOCATED_TEMPLATE__ from './filter-block-editor.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/require-computed-property-dependencies */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable ember/no-jquery */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import $ from 'jquery';
import { computed, action } from '@ember/object';
import { not, and, or } from '@ember/object/computed';
import Component from '@ember/component';
export default Component.extend({
  attributeBindings: ['data-test-send-to-salesforce-block-editor'],
  isOpen: false,
  isOneLine: false,
  constrainDropdownToOpener: not('isOneLine'),
  appearance: null,
  isValid: not('isInvalid'),
  showFilterBlockAsValidBecauseValidAtOpen: and('isOpen', 'validAtOpen'),
  showFilterBlockAsValid: or('isValid', 'justAdded', 'showFilterBlockAsValidBecauseValidAtOpen'),
  showFilterBlockAsInvalid: not('showFilterBlockAsValid'),
  justAdded: false,
  heightOfOpenedFilterBlock: 33,
  overlayComponent: 'filter-block/filter-block-options',
  componentAttrs: computed('overlayParams', 'onUpdate', 'justAdded', 'isOneLine', 'validAtOpen', 'showOnlyLiveContent', function () {
    let p = this.getProperties('overlayParams', 'attrs.onUpdate', 'justAdded', 'isOneLine', 'validAtOpen', 'showOnlyLiveContent');
    return Object.assign(p.overlayParams, {
      onUpdate: p['attrs.onUpdate'],
      forceDisplayAsValid: Boolean(p.justAdded || p.validAtOpen),
      isOneLine: p.isOneLine
    });
  }),
  didInsertElement() {
    this._super(...arguments);
    let height = $(this.element).height();
    let details = $('.filter-block__details', this.element).not('.o__one-line, .o__full-description');
    let heightOfDetails = details.length > 0 ? details.outerHeight() : 0;
    let heightOfOpenedFilterBlock = height - heightOfDetails;
    this.set('heightOfOpenedFilterBlock', heightOfOpenedFilterBlock);
  },
  onOpenAction: action(function () {
    this.set('validAtOpen', this.isValid);
    this.set('isOpen', true);
    if (this.onOpen) {
      this.onOpen();
    }
  }),
  onCloseAction: action(function () {
    this.set('isOpen', false);
    if (this.onClose) {
      this.onClose();
    }
  })
});